import { reduxForm } from 'redux-form';
import ClubEditForm from './ClubEditForm';
import validateTool from 'validate.js';

const validate = (data) => {


  return validateTool(data, {
    name: {
      presence: true
    }
  }) || {};
};



export default reduxForm(
  {
    form: 'club_edit',
    fields: ['name', 'logo', 'info'],
    validate,
    onSubmit: async() => { }
  },
  state => ({
    initialValues: state.club.editModel
  })
)(ClubEditForm);



// WEBPACK FOOTER //
// ./src/components/Clubs/ClubEditForm/index.js